import React, { Fragment } from 'react';
import './styles.css';
import {
  TEACHER,
  ECE
} from '@BUP/constants';
import {
  PageLayout,
  WebinarElement,
  BupSpinner,
  ErrorMessage
} from '@BUP/components';
import { Col, Row } from 'antd';
import { useAuth, useWebinars } from '@BUP/hooks';


const WebinarsPage = () => {
  const { user } = useAuth();
  const { isLoading, data, error } = useWebinars(
    user.organizations.id,
    user.roles.id
  );

  if (error) return <ErrorMessage />;

  return (
    <PageLayout pageName="Seminarios Web">
      <div className="webinars-page-container">
        {isLoading ?
          (
            <BupSpinner size="large" />
          ) :
          data && data.length ? (
            <Fragment>
              <div className="title-wrapper">
                {user?.roles?.type === (TEACHER || ECE) ? (
                  <p>
                    Para conocer más y aprender sobre la convivencia escolar, el
                    mundo digital de tus estudiantes y cómo acompañarlos(as),
                    los(as) invitamos a participar de nuestras charlas web. En
                    este espacio podrás acceder a éstas en vivo e interactuar
                    dejando tus preguntas y comentarios en el chat que estará
                    disponible (solo podrás comentar si estás registrado en
                    Youtube o con tu usuario Gmail). Recuerda que la charla
                    quedará disponible en la plataforma durante dos semanas, por
                    lo que podrás verlas nuevamente si quisieras revisar y
                    profundizar en el contenido de éstas.
                  </p>
                ) : (
                  <p>
                    Para conocer más y aprender sobre la convivencia escolar, el
                    mundo digital de tus hijos(as) y cómo acompañarlos(as),
                    los(as) invitamos a participar de nuestras charlas web. En
                    este espacio podrás acceder a éstas en vivo e interactuar
                    dejando tus preguntas y comentarios en el chat que estará
                    disponible (solo podrás comentar si estás registrado en
                    Youtube o con tu usuario Gmail). Si no pudiste conectarte el
                    día y horario en que se llevó a cabo la charla, recuerda que
                    estas quedarán disponibles durante 2 semanas en la plataforma.
                  </p>
                )}
              </div>
              <Row className="select-webinar-wrapper">
                {data.map((webinar, idx) => (
                  <Col
                    xs={24}
                    md={12}
                    xl={8}
                    className="element-wrapper"
                    key={`webinar-${idx}`}
                  >
                    <WebinarElement
                      key={`webinar-element-${idx}`} 
                      webinar={webinar} 
                    />
                  </Col>
                ))}
              </Row>
            </Fragment>
          ) : (
            <div className="empty-webinars">
              <h1>No existen Webinars</h1>
            </div>
          )}
      </div>
    </PageLayout>
  );
};

export default WebinarsPage;
